/* iPhone Pluggz extras: gallery slides, grouped storage cards, storage selector, scroll motion, sticky add-to-cart, wishlist message */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var behavior = reduce ? 'auto' : 'smooth';
  var HAS_IO = 'IntersectionObserver' in window;
  var LABEL = { 'new': 'Brand New', a: 'Grade A', b: 'Grade B', c: 'Grade C' };
  var SHORT = { 'new': 'New', a: 'A', b: 'B', c: 'C' };
  var ICON = {
    x: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    l: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    r: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };
  var pref = 'R ';

  function toast(msg, action) {
    var t = document.createElement('div');
    t.setAttribute('role', 'status');
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#0c0c0e;color:#fff;padding:12px 18px;border-radius:12px;z-index:200;font-size:14px;box-shadow:0 10px 30px rgba(0,0,0,.25);display:flex;gap:14px;align-items:center;max-width:calc(100vw - 32px)';
    t.appendChild(document.createTextNode(msg));
    if (action) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = action.label;
      b.style.cssText = 'background:none;border:0;color:#7fb2ff;font:inherit;font-weight:700;padding:10px 6px;cursor:pointer';
      b.addEventListener('click', function () { action.fn(); t.remove(); });
      t.appendChild(b);
    }
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4200);
  }
  function fmt(c) { var v = c / 100; return pref + v.toLocaleString('en-US', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }); }
  function tokenOf(title) {
    var w = String(title).split(/\s+/);
    for (var i = w.length - 1; i >= 0; i--) { if (/^\d+(gb|tb|mm)$/i.test(w[i])) return w[i]; }
    return '';
  }
  function modelOf(title, tok) { return String(title).split(tok).join('').replace(/\s+/g, ' ').trim(); }
  function sizeVal(s) {
    var m = String(s).match(/^(\d+)(gb|tb|mm)$/i); if (!m) return 0;
    return m[2].toLowerCase() === 'tb' ? +m[1] * 1024 : +m[1];
  }
  function gradeOf(tags) {
    var t = (tags || []).map(function (x) { return String(x).toLowerCase(); });
    if (t.indexOf('brand new') > -1) return 'new';
    if (t.indexOf('grade a') > -1) return 'a';
    if (t.indexOf('grade b') > -1) return 'b';
    if (t.indexOf('grade c') > -1) return 'c';
    return '';
  }

  /* ---------- wishlist: removed message with a link to the wishlist, heart pop ---------- */
  var WKEY = 'pz-wish';
  function wget() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  var wbefore = [];
  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-pz-wish]'); if (!w) return;
    var h = w.dataset.pzWish; wbefore = wget();
    if (w.classList.contains('pz-heart')) { w.classList.add('is-pop'); setTimeout(function () { w.classList.remove('is-pop'); }, 450); }
    setTimeout(function () {
      var after = wget();
      if (wbefore.indexOf(h) > -1 && after.indexOf(h) === -1) {
        toast('Removed from your wishlist', {
          label: 'View', fn: function () {
            var o = document.querySelector('[data-pz-open="wishlist"]');
            if (o) o.click();
          }
        });
      }
    }, 0);
  }, true);

  /* ---------- product gallery: swipe slides, thumbnails, dots, zoom view ---------- */
  function initGallery() {
    var g = $('[data-pzg]'); if (!g) return;
    var track = $('[data-pzg-track]', g), slides = $$('[data-pzg-slide]', g);
    if (!track || !slides.length) return;
    var thumbs = $$('[data-pzg-thumb]', g), dots = $$('[data-pzg-dot]', g), count = $('[data-pzg-count]', g),
      prev = $('[data-pzg-go="-1"]', g), next = $('[data-pzg-go="1"]', g), thumbBox = $('[data-pzg-thumbs]', g),
      n = slides.length, cur = 0, moved = 0;
    var w = function () { return track.clientWidth || 1; };
    function to(i, instant) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * w(), behavior: instant ? 'auto' : behavior }); }
    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + n;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      if (thumbBox && thumbs[i]) {
        var tr = thumbs[i].getBoundingClientRect(), br = thumbBox.getBoundingClientRect();
        if (thumbBox.scrollHeight > thumbBox.clientHeight + 1) thumbBox.scrollTop += (tr.top - br.top) - (br.height - tr.height) / 2;
        else if (thumbBox.scrollWidth > thumbBox.clientWidth + 1) thumbBox.scrollLeft += (tr.left - br.left) - (br.width - tr.width) / 2;
      }
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / w()); if (i !== cur) mark(i); });
    }, { passive: true });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { to(k); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { to(k); }); });
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); to(cur - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); to(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { to(cur - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { to(cur + 1); e.preventDefault(); }
    });
    window.addEventListener('resize', function () { to(cur, true); });

    /* mouse drag (touch uses native swipe) */
    var down = false, sx = 0, sl = 0, start = 0, lastX = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; sx = lastX = e.clientX; sl = track.scrollLeft; start = cur; moved = 0; track.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; lastX = e.clientX; var dx = lastX - sx; moved = Math.max(moved, Math.abs(dx)); track.scrollLeft = sl - dx;
    });
    function endDrag() {
      if (!down) return; down = false;
      var dx = lastX - sx; to(Math.abs(dx) > 60 ? start + (dx < 0 ? 1 : -1) : start);
      setTimeout(function () { track.classList.remove('is-drag'); }, reduce ? 0 : 500);
    }
    window.addEventListener('pointerup', endDrag); window.addEventListener('pointercancel', endDrag);

    /* images fade in as they load */
    var imgs = $$('img', track);
    imgs.forEach(function (im) {
      var ok = function () { im.classList.add('is-loaded'); };
      if (im.complete && im.naturalWidth) ok(); else { im.addEventListener('load', ok); im.addEventListener('error', ok); }
    });
    setTimeout(function () { imgs.forEach(function (im) { im.classList.add('is-loaded'); }); }, 4000);

    /* colour change scrolls to that colour's photo */
    var vd = $('[data-pz-variants]'), variants = [];
    try { variants = vd ? JSON.parse(vd.textContent) : []; } catch (e) { }
    var fname = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
    function goVariant(instant) {
      var idEl = $('[data-pz-form] [name=id]'); if (!idEl) return;
      var v = variants.filter(function (x) { return String(x.id) === String(idEl.value); })[0];
      /* Not every variant has its own linked photo in Shopify admin (a catalog data gap on
         some products, not something this script can invent). When there's no match, fall
         back to slide 0 explicitly rather than leaving whatever slide a PREVIOUS selection
         left the gallery on - without this, switching from an imaged colour to an un-imaged
         one left the wrong colour's photo on screen instead of the generic/primary photo. */
      if (!v || !v.featured_image) { to(0, instant); return; }
      var f = fname(v.featured_image);
      for (var k = 0; k < slides.length; k++) { if (slides[k].dataset.file === f) { to(k, instant); return; } }
      to(0, instant);
    }
    $$('[data-pz-opt]').forEach(function (i) { i.addEventListener('change', function () { setTimeout(function () { goVariant(false); }, 0); }); });
    /* Always sync on load, not just when a ?variant= param is present - the hidden id
       input already reflects the real default/selected variant either way, so without
       this a fresh visit could show slide 1 (whatever was uploaded first) while the
       colour selector shows a completely different colour already "selected". */
    goVariant(true);

    /* zoom view with its own slides */
    var lb, lbTrack, lbCount, lbIdx = 0, lastFocus, lbRaf;
    function lbLoad(i) {
      [i - 1, i, i + 1].forEach(function (k) {
        var f = lbTrack.children[k]; if (!f) return;
        var im = f.firstChild; if (!im.getAttribute('src')) im.src = im.dataset.src;
      });
    }
    function lbMark(i) { lbIdx = i; lbCount.textContent = (i + 1) + ' / ' + n; lbLoad(i); }
    function lbGo(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: instant ? 'auto' : behavior });
    }
    function closeLb() {
      if (!lb || !lb.classList.contains('is-on')) return;
      lb.classList.remove('is-on'); document.documentElement.classList.remove('pz-lock');
      to(lbIdx, true); if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function buildLb() {
      lb = document.createElement('div'); lb.className = 'pzlb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product images');
      lb.innerHTML = '<button type="button" class="pzlb__x" aria-label="Close">' + ICON.x + '</button><div class="pzlb__track"></div>' +
        (n > 1 ? '<button type="button" class="pzlb__a pzlb__a--l" aria-label="Previous image">' + ICON.l + '</button><button type="button" class="pzlb__a pzlb__a--r" aria-label="Next image">' + ICON.r + '</button>' : '') +
        '<span class="pzlb__n"></span>';
      lbTrack = $('.pzlb__track', lb); lbCount = $('.pzlb__n', lb);
      slides.forEach(function (s) {
        var f = document.createElement('figure'); f.className = 'pzlb__s';
        var im = document.createElement('img'); im.alt = ($('img', s) || {}).alt || ''; im.dataset.src = s.dataset.big || ($('img', s) || {}).src;
        f.appendChild(im); lbTrack.appendChild(f);
      });
      $('.pzlb__x', lb).addEventListener('click', closeLb);
      lbTrack.addEventListener('click', function (e) { if (e.target.tagName !== 'IMG') closeLb(); });
      var l = $('.pzlb__a--l', lb), r = $('.pzlb__a--r', lb);
      if (l) l.addEventListener('click', function () { lbGo(lbIdx - 1); });
      if (r) r.addEventListener('click', function () { lbGo(lbIdx + 1); });
      lbTrack.addEventListener('scroll', function () {
        cancelAnimationFrame(lbRaf);
        lbRaf = requestAnimationFrame(function () { var i = Math.round(lbTrack.scrollLeft / (lbTrack.clientWidth || 1)); if (i !== lbIdx) lbMark(i); });
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-on')) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft') lbGo(lbIdx - 1);
        else if (e.key === 'ArrowRight') lbGo(lbIdx + 1);
      });
      document.body.appendChild(lb);
    }
    function openLb(i) {
      if (!lb) buildLb();
      lastFocus = document.activeElement;
      lb.classList.add('is-on'); document.documentElement.classList.add('pz-lock');
      lbTrack.style.scrollBehavior = 'auto'; lbTrack.scrollLeft = i * lbTrack.clientWidth; lbTrack.style.scrollBehavior = '';
      lbMark(i); $('.pzlb__x', lb).focus();
    }
    slides.forEach(function (s, k) {
      s.addEventListener('click', function () { if (moved > 6) { moved = 0; return; } openLb(k); });
    });
    mark(0);
  }

  /* ---------- product page: storage / condition selector from sibling listings ---------- */
  function initSiblings() {
    var box = $('[data-pz-sib]'); if (!box) return;
    var coll = box.dataset.coll, model = String(box.dataset.model || '').toLowerCase(), cur = box.dataset.current;
    var pe = $('[data-pz-price]'); if (pe && !/^R\s/.test(pe.textContent.trim())) pref = 'R';
    var key = 'pz-sib2-' + coll, cached = null;
    try {
      cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && (Date.now() - cached.t > 600000 || !Array.isArray(cached.d) || !cached.d.length || !cached.d[0].h)) cached = null;
    } catch (e) { cached = null; }
    function loadAll() {
      var out = [];
      function page(k) {
        return fetch('/collections/' + coll + '?view=pzsib&page=' + k)
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (!Array.isArray(j)) throw new Error('unexpected response');
            out = out.concat(j);
            return j.length >= 50 && k < 6 ? page(k + 1) : out;
          });
      }
      return page(1);
    }
    function chip(it, label, on) {
      return '<a class="pz-sibc' + (on ? ' is-on' : '') + '" href="/products/' + it.h + '"' + (on ? ' aria-current="page"' : '') + '>' + label + (it.a ? '' : '<small>Sold out</small>') + '</a>';
    }
    function render(list) {
      var items = [];
      list.forEach(function (x) {
        var tok = tokenOf(x.t); if (!tok || modelOf(x.t, tok).toLowerCase() !== model) return;
        items.push({ h: x.h, tok: tok.toUpperCase(), size: sizeVal(tok), p: x.p, a: x.a, grade: gradeOf(x.g) });
      });
      var me = items.filter(function (i) { return i.h === cur; })[0];
      if (!me || items.length < 2) return;
      var html = '', seen = {}, tokens = [];
      items.forEach(function (i) { if (!seen[i.tok]) { seen[i.tok] = 1; tokens.push(i); } });
      tokens.sort(function (a, b) { return a.size - b.size; });
      if (tokens.length > 1) {
        html += '<fieldset class="pz-opt"><legend>' + (/MM$/.test(me.tok) ? 'Size' : 'Storage') + '</legend><div class="pz-opt__v">';
        tokens.forEach(function (t) {
          var pool = items.filter(function (i) { return i.tok === t.tok; }), pick;
          if (t.tok === me.tok) pick = me;
          else { pick = pool.filter(function (i) { return i.grade === me.grade; })[0] || pool.sort(function (a, b) { return a.p - b.p; })[0]; }
          html += chip(pick, t.tok, t.tok === me.tok);
        });
        html += '</div></fieldset>';
      }
      var same = items.filter(function (i) { return i.tok === me.tok; });
      if (same.length > 1) {
        html += '<fieldset class="pz-opt"><legend>Condition</legend><div class="pz-opt__v">';
        same.sort(function (a, b) { return b.p - a.p; }).forEach(function (i) { html += chip(i, LABEL[i.grade] || 'Other', i.h === me.h); });
        html += '</div></fieldset>';
      }
      if (!html) return;
      box.innerHTML = html; box.hidden = false;
    }
    (cached ? Promise.resolve(cached.d) : loadAll()).then(function (list) {
      if (!cached) { try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: list })); } catch (e) { } }
      render(list);
    }).catch(function () { });
  }

  /* ---------- cards: one card per model with its storage sizes ---------- */
  function orig(c) {
    if (c._o) return c._o;
    var st = $('[data-pz-stor]', c), foot = $('.pz-card__foot', c), price = $('.pz-price', c), fin = $('.pz-fincompact', c);
    c._o = { stor: st ? st.innerHTML : '', foot: foot ? foot.innerHTML : '', price: price ? price.innerHTML : '', fin: fin ? fin.outerHTML : '', badge: $('.pz-card__media .pz-badge', c) };
    return c._o;
  }
  function renderGroups(box) {
    var cards = $$('.pz-card[data-model]', box); if (!cards.length) return;
    var chipOn = $('.pz-chip.is-on[data-pz-chip]'), gf = chipOn ? chipOn.dataset.pzChip : 'all';
    cards.forEach(function (c) {
      var o = orig(c);
      c.classList.remove('is-merged', 'is-group');
      var st = $('[data-pz-stor]', c), foot = $('.pz-card__foot', c), price = $('.pz-price', c);
      if (st) st.innerHTML = o.stor; if (foot) foot.innerHTML = o.foot; if (price) price.innerHTML = o.price;
      if (o.badge) o.badge.style.display = '';
      var fn = $('.pz-fincompact', c); if (fn && o.fin) fn.outerHTML = o.fin;
    });
    var groups = {}, order = [];
    cards.forEach(function (c) {
      if (gf !== 'all' && c.dataset.grade !== gf) return;
      var k = c.dataset.model; if (!groups[k]) { groups[k] = []; order.push(k); }
      groups[k].push(c);
    });
    order.forEach(function (k) {
      var list = groups[k]; if (list.length < 2) return;
      var rep = list[0];
      var mem = list.map(function (c) {
        return { el: c, storage: c.dataset.storage, size: sizeVal(c.dataset.storage), grade: c.dataset.grade, price: +c.dataset.price, url: c.dataset.url, avail: c.dataset.avail === 'true' };
      }).sort(function (a, b) { return a.size - b.size || a.price - b.price; });
      var min = mem.slice().sort(function (a, b) { return a.price - b.price; })[0];
      var tmp = document.createElement('div'); tmp.innerHTML = orig(min.el).price;
      var first = $('span', tmp), priceText = first ? first.textContent : '';
      var pr = $('.pz-price', rep);
      if (pr) { pr.innerHTML = '<small class="pz-from">From</small><span></span>'; pr.lastChild.textContent = priceText; }
      var rf = $('.pz-fincompact', rep), mf = orig(min.el).fin; if (rf && mf) rf.outerHTML = mf;
      var cnt = {}; mem.forEach(function (m) { cnt[m.storage] = (cnt[m.storage] || 0) + 1; });
      var row = $('[data-pz-stor]', rep);
      if (row) {
        row.innerHTML = '';
        var uniq = [];
        mem.forEach(function (m) {
          if (uniq.indexOf(m.storage) < 0) uniq.push(m.storage);
          var a = document.createElement('a'); a.className = 'pz-stor__c'; a.href = m.url;
          a.textContent = m.storage + (cnt[m.storage] > 1 && SHORT[m.grade] ? ' · ' + SHORT[m.grade] : '');
          row.appendChild(a);
        });
        var sum = document.createElement('span'); sum.className = 'pz-stor__sum';
        sum.textContent = uniq.length > 2 ? uniq[0] + ' to ' + uniq[uniq.length - 1] : uniq.join(' · ');
        row.appendChild(sum);
      }
      var any = mem.some(function (m) { return m.avail; }), foot = $('.pz-card__foot', rep);
      var kind = /mm$/i.test(mem[0].storage) ? 'size' : 'storage';
      if (foot) foot.innerHTML = '<span class="pz-stock' + (any ? '' : ' pz-stock--out') + '">' + (any ? 'In stock' : 'Sold out') + '</span><a class="pz-add pz-add--ghost" href="' + rep.dataset.url + '">Choose ' + kind + '</a>';
      var grades = {}; mem.forEach(function (m) { grades[m.grade] = 1; });
      if (Object.keys(grades).length > 1 && orig(rep).badge) orig(rep).badge.style.display = 'none';
      rep.classList.add('is-group');
      list.slice(1).forEach(function (c) { c.classList.add('is-merged'); });
    });
    box.classList.add('is-grouped');
  }
  function initGroups() {
    var boxes = $$('[data-pz-group]'); if (!boxes.length) return;
    function all() { boxes.forEach(renderGroups); }
    all();
    boxes.forEach(function (b) {
      if (!('MutationObserver' in window)) return;
      var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { renderGroups(b); }, 30); }).observe(b, { childList: true });
    });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-pz-chip]')) setTimeout(all, 0); });
    window.addEventListener('hashchange', function () { setTimeout(all, 0); });
  }

  /* ---------- scroll motion ---------- */
  var REVEAL = '.pz-sechead,.pz-grade,.pz-cat,.pz-why__i,.pz-review,.pz-photo,.pz-q,.pz-tin,.pz-step,.pz-info,.pz-feat a,.pz-psec,.pz-cta-band,.pz-serie,.pz-stat,.pz-pricecard,.pz-post,.pz-store__info,.pz-map,.pz-card,.pz-panelbox,.pz-plist li';
  function initReveal() {
    if (reduce || !HAS_IO) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        var el = x.target; io.unobserve(el); el.classList.add('is-in');
        var d = 900 + (+el.style.getPropertyValue('--i') || 0) * 70;
        setTimeout(function () { el.classList.remove('pz-rv', 'is-in'); el.style.removeProperty('--i'); }, d);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    function tag(root) {
      var idx = new Map();
      $$(REVEAL, root).forEach(function (el) {
        if (el.classList.contains('pz-rv') || el.closest('.pz-panel') || el.closest('.pzlb') || el.closest('[data-pz-header]')) return;
        var r = el.getBoundingClientRect();
        if (r.width && r.top < window.innerHeight * 0.98 && r.bottom > 0) return;
        var p = el.parentNode, i = idx.get(p) || 0; idx.set(p, i + 1);
        el.style.setProperty('--i', i % 5); el.classList.add('pz-rv'); io.observe(el);
      });
    }
    tag(document);
    if ('MutationObserver' in window) {
      $$('.pz-grid,.pz-rail,.pz-results,.pz-colgrid').forEach(function (g) {
        new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (nd) { if (nd.nodeType === 1) { if (nd.matches && nd.matches(REVEAL)) { var r = nd.getBoundingClientRect(); if (!(r.top < window.innerHeight)) { nd.classList.add('pz-rv'); io.observe(nd); } } } }); }); }).observe(g, { childList: true });
      });
    }
  }

  /* ---------- cart bubble bump ---------- */
  function initBump() {
    $$('[data-pz-count]').forEach(function (b) {
      var last = +b.textContent || 0;
      if (!('MutationObserver' in window)) return;
      new MutationObserver(function () {
        var nn = +b.textContent || 0;
        if (nn > last) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }
        last = nn;
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- product page: sticky add-to-cart on phones ---------- */
  function initSticky() {
    var pdp = $('[data-pz-pdp]'), btn = pdp && $('[data-pz-submit]', pdp);
    if (!btn) return;
    var title = $('h1', pdp), price = $('[data-pz-price]', pdp), foot = $('footer');
    var bar = document.createElement('div'); bar.className = 'pz-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="pz-sticky__i"><div class="pz-sticky__t"><b></b><span></span></div><button type="button" class="pz-btn pz-sticky__b" tabindex="-1"></button></div>';
    var sb = $('.pz-sticky__b', bar);
    $('b', bar).textContent = title ? title.textContent.trim() : '';
    function sync() {
      $('span', bar).textContent = price ? price.textContent : '';
      var lab = btn.querySelector('span'); sb.textContent = lab ? lab.textContent : 'Add to cart';
      sb.disabled = btn.disabled;
    }
    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
      if (price) new MutationObserver(sync).observe(price, { childList: true, characterData: true, subtree: true });
    }
    sb.addEventListener('click', function () { btn.click(); });
    document.body.appendChild(bar);
    var ticking = false;
    function measure() {
      ticking = false;
      var past = btn.getBoundingClientRect().bottom < 0;
      var atFoot = !!foot && foot.getBoundingClientRect().top < window.innerHeight - 60;
      var on = past && !atFoot;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); sb.tabIndex = on ? 0 : -1;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }, { passive: true });
    window.addEventListener('resize', measure);
    measure();
  }

  function boot() {
    try { initGallery(); } catch (e) { }
    try { initSiblings(); } catch (e) { }
    try { initGroups(); } catch (e) { }
    try { initReveal(); } catch (e) { }
    try { initBump(); } catch (e) { }
    try { initSticky(); } catch (e) { }
  }
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();